// Product gallery: the images form a scroll-snap strip; this adds prev/next, a counter, thumbnails and a full-screen viewer.
const gallery = document.querySelector<HTMLElement>("[data-gallery]")
const track = gallery?.querySelector<HTMLElement>("[data-gallery-track]")

if (gallery && track) {
  const photos = [...track.querySelectorAll<HTMLAnchorElement>("[data-gallery-zoom]")]
  const thumbs = [...gallery.querySelectorAll<HTMLAnchorElement>("[data-gallery-thumb]")]
  const nav = gallery.querySelector<HTMLElement>("[data-gallery-nav]")
  const counter = gallery.querySelector<HTMLElement>("[data-gallery-counter]")
  const total = photos.length
  const smooth = !matchMedia("(prefers-reduced-motion: reduce)").matches
  const clamp = (index: number) => Math.min(Math.max(index, 0), total - 1)
  const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))
  const show = (index: number) =>
    track.scrollTo({ left: clamp(index) * track.clientWidth, behavior: smooth ? "smooth" : "auto" })

  const update = () => {
    const index = current()
    if (counter) counter.textContent = `${index + 1} / ${total}`
    thumbs.forEach((thumb, i) => thumb.setAttribute("aria-current", String(i === index)))
  }

  nav?.querySelector("[data-gallery-prev]")?.addEventListener("click", () => show(current() - 1))
  nav?.querySelector("[data-gallery-next]")?.addEventListener("click", () => show(current() + 1))
  thumbs.forEach((thumb, index) =>
    thumb.addEventListener("click", (event) => {
      event.preventDefault()
      show(index)
    }),
  )
  track.addEventListener("scroll", update, { passive: true })
  update()
  if (nav) nav.hidden = false

  const viewer = gallery.querySelector<HTMLDialogElement>("[data-gallery-viewer]")
  const image = viewer?.querySelector<HTMLImageElement>("[data-viewer-image]")
  if (viewer && image) {
    const viewerCounter = viewer.querySelector<HTMLElement>("[data-viewer-counter]")
    let index = 0
    let swipeStart = 0
    const open = (next: number) => {
      index = clamp(next)
      image.src = photos[index]?.href ?? ""
      image.alt = photos[index]?.querySelector("img")?.alt ?? ""
      if (viewerCounter) viewerCounter.textContent = `${index + 1} / ${total}`
    }

    photos.forEach((photo, i) =>
      photo.addEventListener("click", (event) => {
        event.preventDefault()
        open(i)
        viewer.showModal()
      }),
    )
    viewer.querySelector("[data-viewer-close]")?.addEventListener("click", () => viewer.close())
    viewer.querySelector("[data-viewer-prev]")?.addEventListener("click", () => open(index - 1))
    viewer.querySelector("[data-viewer-next]")?.addEventListener("click", () => open(index + 1))
    viewer.addEventListener("click", (event) => {
      const swiped = Math.abs(event.clientX - swipeStart) > 10
      if (event.target === viewer && !swiped) viewer.close()
    })
    viewer.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") open(index - 1)
      if (event.key === "ArrowRight") open(index + 1)
    })

    viewer.addEventListener("pointerdown", (event) => (swipeStart = event.clientX))
    viewer.addEventListener("pointerup", (event) => {
      const distance = event.clientX - swipeStart
      if (Math.abs(distance) > 50) open(index + (distance < 0 ? 1 : -1))
    })
    viewer.addEventListener("close", () => track.scrollTo({ left: index * track.clientWidth }))
  }
}
